// cookieSettingsContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';

const CookieSettingsContext = createContext();

export const CookieSettingsProvider = ({ children }) => {
    const [cookieSettings, setCookieSettings] = useState(() => {
        const savedSettings = getCookie('cookieSettings');
        return savedSettings ? JSON.parse(savedSettings) : { 'Analytics Cookies': false, 'Marketing Cookies': false, 'Necessary Cookies': true };
    });

    useEffect(() => {
        setCookie('cookieSettings', JSON.stringify(cookieSettings), 365);
    }, [cookieSettings]);
    

    return (
        <CookieSettingsContext.Provider value={{ cookieSettings, setCookieSettings }}>
            {children}
        </CookieSettingsContext.Provider>
    );
};


export const useCookieSettings = () => useContext(CookieSettingsContext);


function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i=0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
